import script from "./PlaylistsCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaylistsCreate.vue?vue&type=script&setup=true&lang=js"

import "./PlaylistsCreate.vue?vue&type=style&index=0&id=773b8baf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-773b8baf"]])

export default __exports__